import { HttpClient } from '@angular/common/http';
import { AuthService } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { skipAuthErrorToast } from '../../http-error.interceptor';

/**
 * Attempts to link Auth0 accounts by copying tenant metadata from an
 * older identity (e.g. Username-Password-Authentication) to the current
 * one (e.g. passwordless email).
 *
 * Returns the tenants array from the linked account, or [] if no donor found.
 * On success, also refreshes the access token so subsequent requests carry
 * the updated claims.
 */
export async function tryLinkAccounts(
  http: HttpClient,
  auth: AuthService
): Promise<string[]> {
  const result = await firstValueFrom(
    // Background flow: failures are expected for some users and handled
    // by the callers — never surface a generic auth-error toast.
    http.post<{ tenants: string[] }>(
      '/api/auth/link-accounts',
      {},
      { context: skipAuthErrorToast() }
    )
  );

  if (result.tenants.length > 0) {
    // Force token refresh so the JWT includes the new tenants claim.
    await firstValueFrom(auth.getAccessTokenSilently({ cacheMode: 'off' }));
  }

  return result.tenants;
}
